import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { formats } from '../../utils/Localization.js';
import { fComp } from '../../utils/React.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import { TwoLineItemPresentation } from '../TwoLineItem/TwoLineItemPresentation.js';
import { hostClass } from './TextHighlight.styles.js';

var defaultProps = {
  centeredLayout: false,
  headline: "",
  subline: "",
  isLongText: false,
  noQuotes: false,
  thumbIconName: "",
  thumbIconVariant: "solid",
  thumbIconTitle: "",
  thumbText: "",
  thumbImgSrc: "",
  manualHyphenation: false
};
var TextHighlightPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;
  var id = props.id,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    headline = props.headline,
    subline = props.subline,
    isLongText = props.isLongText,
    noQuotes = props.noQuotes,
    text = props.text,
    thumbIconName = props.thumbIconName,
    thumbIconVariant = props.thumbIconVariant,
    thumbIconTitle = props.thumbIconTitle,
    thumbText = props.thumbText,
    thumbImgSrc = props.thumbImgSrc,
    iconLinks = props.iconLinks,
    centeredLayout = props.centeredLayout,
    manualHyphenation = props.manualHyphenation;
  var hasInformation = !!thumbText || !!thumbIconName || !!thumbImgSrc || !!headline;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "-centered-layout"), centeredLayout), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-contents"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-contents__long-text"), isLongText), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-contents__long-text____hyphens-manual"), manualHyphenation), _cleanupClassObject2))
  }, !noQuotes && formats.quotationMarkOpening, text, !noQuotes && formats.quotationMarkClosing), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-footer")
  }, hasInformation && /*#__PURE__*/React.createElement(TwoLineItemPresentation, {
    noMargin: true,
    src: thumbImgSrc,
    text: thumbText,
    iconName: thumbIconName,
    iconVariant: thumbIconVariant,
    iconTitle: thumbIconTitle,
    headline: headline,
    subline: subline,
    centeredLayout: centeredLayout
  }), iconLinks && /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    direction: "table",
    noMargin: true
  }, iconLinks)));
}, defaultProps);
TextHighlightPresentation.displayName = "TextHighlightPresentation";

export { TextHighlightPresentation, defaultProps };
